import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {
    static targets = ["score", "rankBadge"]
    static values = { userId: Number }

    connect() {
        if (this.hasUserIdValue) {
            this.subscription = consumer.subscriptions.create(
                { channel: "UsageChannel", user_id: this.userIdValue },
                {
                    received: (data) => this.handleUpdate(data)
                }
            )
        }
    }

    disconnect() {
        if (this.subscription) {
            this.subscription.unsubscribe()
        }
    }

    handleUpdate(data) {
        if (data.type === "score_update") {
            this.updateScore(data)
        }
    }

    updateScore(data) {
        if (this.hasScoreTarget) {
            this.scoreTarget.textContent = `${data.total_score} pt`
        }

        if (this.hasRankBadgeTarget) {
            // ランクが変わった場合のクラス変更ロジック（簡易版）
            // 完全にDOMを再構築するのは複雑なので、テキストと基本クラスを更新
            this.rankBadgeTarget.textContent = `RANK ${data.rank}`

            // クラスをリセットして再適用
            this.rankBadgeTarget.className = `px-1.5 py-0.5 rounded text-[10px] font-bold border ${this.getRankClasses(data.rank)}`
        }
    }

    getRankClasses(rank) {
        switch (rank) {
            case 'S': return 'bg-yellow-500 text-black border-yellow-600'
            case 'A': return 'bg-red-500 text-white border-red-600'
            case 'B': return 'bg-blue-500 text-white border-blue-600'
            default: return 'bg-slate-600 text-slate-300 border-slate-700'
        }
    }
}
